import { Routes } from '@angular/router';

import { wolfAiRoutes } from '@advania-cosoftware/wolf-ai';
import { pricelistManagementRoutes } from '@advania-cosoftware/wolf-pricelist-management';
import { aiSegments } from '@advania-cosoftware/wolf-router';

export const internalRoutes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: aiSegments.aiChat },
    ...wolfAiRoutes(),
    ...pricelistManagementRoutes,
    { path: '**', redirectTo: aiSegments.aiChat },
];
